// Printed documents are always Finnish, whatever the interface language.
import i18n from "@/i18n";

export const tFi = i18n.getFixedT("fi");

export function fiDate(iso, opts) {
    return new Date(iso).toLocaleDateString("fi-FI", opts);
}

export function fiStatus(status) {
    if (!status) return "";
    return tFi(`prep.status.${status}`, { defaultValue: tFi(`weeklyMenu.dayStatus.${status}`, { defaultValue: status }) });
}
